import React, {useContext, useState} from 'react';
import {useSelector} from 'react-redux';
import CustomTable from '../../CoreWrappers/CustomTable';
import {labels} from '../../../util/utils';
import {createProjectStepsIndex} from '../../../util/uiconstants';
import utilityfunctions from '../../../util/utilityfunctions';
import Badge from '../../CoreWrappers/Badge';
import {IconoirEditPencil, IconoirEnlarge} from '@ey-xd/motif-icon';
import styled from 'styled-components';
import _ from 'lodash';
import selectAllClients from '../../../reducers/Clients/selectors/selectAllClients';
import {ProjectContext} from './Helper/context';
import Modal from '../../CoreWrappers/Modal';
import Button from '../../CoreWrappers/Button';

const ClientsTable = (props) => {
	const {state, dispatch} = useContext(ProjectContext);
	const isEditMode = useSelector((state) => state.isEditMode.activated);
	const isRollForwardMode = useSelector((state) => state.isRollForwardMode);
	const [isModalVisible, setModalVisibility] = useState(false);

	let selectedClients = useSelector((store) =>
		isEditMode || isRollForwardMode
			? [...state.clients].sort((a, b) => a.name.localeCompare(b.name))
			: [...store.newProject.clients].sort((a, b) => a.name.localeCompare(b.name))
	);

	const allClients = useSelector(selectAllClients);

	const getClientData = () => {
		let clientData = [];
		selectedClients.map((c) => {
			let data = {};
			data.clientName = c.name;
			data.clientCode = c.clientCode;
			let selected = allClients.filter((e) => {
				return c.clientCode === e.clientCode;
			});
			let JoinedString = selected
				.map((a) => {
					return a.sources;
				})
				.join(', ');
			if (JoinedString === '') {
				JoinedString = getMissingClientSource(c);
			}
			data.sources = JoinedString;
			clientData.push(data);
		});
		return clientData;
	};

	const getMissingClientSource = (client) => {
		const selectedClient = props.project?.clients?.find((pc) => pc.clientCode === client.clientCode);
		if (selectedClient) return selectedClient.source;
		return '';
	};

	const clientsConfig = [
		{
			label: labels.client,
			sortable: false,
			sort: 'asc',
			width: '36%',
			propName: 'clientName',
			customHeaderCell: (item) => {
				let result = (
					<>
						{labels.client} <Badge value={selectedClients.length} />
					</>
				);

				return result;
			}
		},
		{label: labels.source, sortable: false, width: '27%', propName: 'sources'},
		{label: labels.code, sortable: false, width: '27%', propName: 'clientCode'},
		{
			label: '',
			sortable: false,
			width: '10%',
			propName: 'icons',
			customHeaderCell: (item) => {
				const propsBtnEdit = {
					svg: IconoirEditPencil,
					iconSize: 20,
					variant: 'text',
					title: labels.edit,
					onClick: () => props.handleEditIconClick(createProjectStepsIndex.selectClient)
				};
				return (
					<>
						<Button {...propsBtnEdit} />
					</>
				);
			}
		}
	];

	const clientsConfigModal = [
		{
			label: labels.client,
			sortable: false,
			sort: 'asc',
			width: '35%',
			propName: 'clientName',
			customColumnHeaderRender: (item) => {
				let result = (
					<>
						<Badge value={selectedClients.length} />
					</>
				);

				return result;
			}
		},
		{label: labels.source, sortable: false, width: '30%', propName: 'sources'},
		{label: labels.code, sortable: false, width: '30%', propName: 'clientCode'}
	];

	return (
		<StyledClientTable>
			<CustomTable
				columns={clientsConfig}
				data={getClientData()}
				showAccordions={false}
				theme={utilityfunctions.getMotifTheme()}
				paginationConfig={{
					disabled: true
				}}
				searchConfig={{
					disabled: true
				}}
				labelConfig={{
					yesLabel: labels.yes,
					noLabel: labels.no
				}}
			/>
			<Modal
				show={isModalVisible}
				onClose={() => setModalVisibility(false)}
				onHide={() => setModalVisibility(false)}
				title={labels.client}
				closeTitle={labels.closeLabel}
				modalContainerClass="step4-clients-modal-expand"
				showFooter={false}
			>
				<StyledModalBody>
					<CustomTable
						columns={clientsConfigModal}
						data={getClientData()}
						theme={utilityfunctions.getMotifTheme()}
						className="modal-table-body"
						showAccordions={false}
						paginationConfig={{
							disabled: true
						}}
						searchConfig={{
							disabled: true
						}}
						labelConfig={{
							yesLabel: labels.yes,
							noLabel: labels.no
						}}
					/>
				</StyledModalBody>
			</Modal>
		</StyledClientTable>
	);
};

export default ClientsTable;

const StyledModalBody = styled.section`
	height: 100%;
	.modal-table-body,
	.motif-card-body,
	.table-body {
		height: calc(100% - 3rem);
	}

	.table-body {
		& > div {
			height: 100%;
		}
	}

	.list-body {
		height: calc(100% - 4.5rem);

		.table-row {
			border-bottom: solid 1px ${(props) => props.theme.color[`grey225`]};
		}
	}
	.group-name {
		max-width: 82%;
		margin-right: 0.5rem;
	}
	.motif-badge {
		margin-right: 1rem;
		.motif-badge-number {
			color: ${(props) => props.theme.color[`white`]};
		}
	}

	.table-header-col-0,
	.table-header-col-1 {
		display: flex;
		align-items: center;
	}

	.table-row {
		.row-cell-0 {
			span {
				margin-right: 2rem;
			}
		}
	}

	.table-header-col-4 {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.row-cell-0,
	.row-cell-1,
	.row-cell-2,
	.row-cell-3,
	.row-cell-4 {
		line-height: normal;
	}
	.table-header {
		background: ${(props) => props.theme.color[`grey100`]};
		border: 1px solid ${(props) => props.theme.color[`grey225`]};
	}
	.table-header-item > div {
		display: flex;
		max-width: 85%;
		.sort-label {
			max-width: 100%;
			margin-right: 0.5rem;
		}
	}

	.ellipsis {
		display: inline-block;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;

const StyledClientTable = styled.section`
	.client-name {
		max-width: 80%;
		margin-right: 0.5rem;
	}
	.motif-icon {
		display: inline-block;
		svg {
			width: 2rem !important;
			height: 2rem !important;
			fill: ${(props) => props.theme.color[`grey500`]};
		}
	}

	.table-header-col-0,
	.table-header-col-1,
	.table-header-col-2 {
		display: flex;
		align-items: center;

		&.table-header-item > div {
			display: flex;
			max-width: 85%;
			.sort-label {
				max-width: 100%;
				margin-right: 0.5rem;
			}
		}
	}

	.table-header-col-3 {
		display: flex;
		align-items: center;
	}

	.list-body {
		.table-row {
			border-bottom: solid 1px ${(props) => props.theme.color[`grey225`]};
		}
	}

	.row-cell-0 {
		span {
			margin-right: 1rem;
		}
	}
	.table-header-col-2 {
		display: flex;
		align-items: center;
	}

	.row-cell-0,
	.row-cell-1,
	.row-cell-2,
	.row-cell-3 {
		line-height: normal;
	}

	.ellipsis {
		display: inline-block;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;
